import { render } from "./PlayingDesk.vue?vue&type=template&id=da9968ee"
import script from "./PlayingDesk.vue?vue&type=script&lang=js"
export * from "./PlayingDesk.vue?vue&type=script&lang=js"

import "./PlayingDesk.vue?vue&type=style&index=0&id=da9968ee&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__